import React from "react";

import { GridOrderItemCardsLoadingSkeleton } from "../../components/GridOrderItemCardsLoadingSkeleton";

export const BrandOrdersLoadingSkeleton: React.FC<{
  isLoading: boolean;
}> = ({ isLoading }) =>
  isLoading ? <GridOrderItemCardsLoadingSkeleton /> : null;
